import { useEffect } from 'react';

function useDocumentTitle(title) {
    useEffect(() => {
        document.title = title + ' - Palace for Life Foundation Draw | Crystal Palace FC Matchday Draw';
    }, [title]); // Re-run the effect when the title changes
}

export default useDocumentTitle;